"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationMarkers = void 0;
class LocationMarkers {
    static init() {
        const map = document.querySelector('section.locations .map-wrapper');
        const markers = document.querySelectorAll('section.locations .location-info');
        if (!map || !markers) {
            return;
        }
        markers.forEach((marker) => {
            var _a;
            (_a = marker.firstElementChild) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', () => {
                map.classList.add(`${marker.dataset.location}`);
            });
            marker.addEventListener('mouseleave', () => {
                map.classList.remove('primary');
                map.classList.remove('secondary');
            });
        });
    }
}
exports.LocationMarkers = LocationMarkers;
